exports.install = function (Vue, enquire) {
  if (this.installed) {
    return
  }

  this.installed = true

  Vue.enquire = enquire

  Object.defineProperty(Vue.prototype, '$enquire', {
    get: function get () { return enquire }
  })
}



// WEBPACK FOOTER //
// ./src/configs/enquirejs/plugin.js